/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 業務処理ステータス 
 * @export
 * @enum {number}
 */
export enum ProcessStatusEnum {
    /** 集計処理正常終了 */
    COMPLETED_AGGREGATED = 0,
    /** 集計処理異常 */
    FAILED = 1,
    /** 支払通知書・精算書公開済み */
    COMPLETED_PUBLISHED = 2,
    /** 支払通知書・精算書・明細データ公開済み */
    COMPLETED_DETAIL_PUBLISHED = 3,
    /** 集計処理中 */
    RUNNING = 4
}

/**
 * 業務処理ステータス  の Union 型
 * @export
 * @typedef ProcessStatus
 */
export type ProcessStatus =
  typeof ProcessStatusEnum[keyof typeof ProcessStatusEnum];

/**
 * 業務処理ステータス  のラベルマップ
 * @export
 */
export const ProcessStatusLabels = {
    /**
     * 数値キー: ProcessStatusEnum.COMPLETED_AGGREGATED
     * 名前キー:  COMPLETED_AGGREGATED
     */
    [ProcessStatusEnum.COMPLETED_AGGREGATED]: '集計処理正常終了',
    COMPLETED_AGGREGATED:                             '集計処理正常終了',
    /**
     * 数値キー: ProcessStatusEnum.FAILED
     * 名前キー:  FAILED
     */
    [ProcessStatusEnum.FAILED]: '集計処理異常',
    FAILED:                             '集計処理異常',
    /**
     * 数値キー: ProcessStatusEnum.COMPLETED_PUBLISHED
     * 名前キー:  COMPLETED_PUBLISHED
     */
    [ProcessStatusEnum.COMPLETED_PUBLISHED]: '支払通知書・精算書公開済み',
    COMPLETED_PUBLISHED:                             '支払通知書・精算書公開済み',
    /**
     * 数値キー: ProcessStatusEnum.COMPLETED_DETAIL_PUBLISHED
     * 名前キー:  COMPLETED_DETAIL_PUBLISHED
     */
    [ProcessStatusEnum.COMPLETED_DETAIL_PUBLISHED]: '支払通知書・精算書・明細データ公開済み',
    COMPLETED_DETAIL_PUBLISHED:                             '支払通知書・精算書・明細データ公開済み',
    /**
     * 数値キー: ProcessStatusEnum.RUNNING
     * 名前キー:  RUNNING
     */
    [ProcessStatusEnum.RUNNING]: '集計処理中',
    RUNNING:                             '集計処理中',
} as const;

/**
 * 業務処理ステータス  のラベル Union 型
 * @export
 * @typedef ProcessStatusLabel
 */
export type ProcessStatusLabel =
  typeof ProcessStatusLabels[keyof typeof ProcessStatusLabels];

/**
 * 業務処理ステータス  のラベル取得関数
 * @export
 * @param { ProcessStatus } value - 列挙体の値
 * @returns { ProcessStatusLabel } ラベル文字列
 */
export function getProcessStatusLabel(
  value: ProcessStatus
): ProcessStatusLabel {
  return ProcessStatusLabels[value];
}

/**
 * 業務処理ステータス  のラベル配列を取得する関数
 * @export
 * @param { ProcessStatus[] } values - 列挙体の値配列
 * @returns { ProcessStatusLabel[] } ラベル文字列配列
 */
export function getProcessStatusLabels(values: ProcessStatus[]): ProcessStatusLabel[] {
  return values.map((value) => getProcessStatusLabel(value));
}

/**
 * 業務処理ステータス  のラベル配列
 * @export
 */
export const ProcessStatusLabelList = [
  '集計処理正常終了','集計処理異常','支払通知書・精算書公開済み','支払通知書・精算書・明細データ公開済み','集計処理中',
] as const;

